import {useLoginContext} from '@hconnect/login'
import {Error403Page} from '@hconnect/uikit/src/lib2'
import React from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

type PermissionDeniedFallbackProps = {
  dataTestId?: string
}

export const PermissionDeniedFallback: React.FC<PermissionDeniedFallbackProps> = ({dataTestId}) => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const {logout} = useLoginContext()

  return (
    <Error403Page
      caption={t('error.accessDenied')}
      description={t('error.accessDeniedDescription')}
      onLogout={() => void logout()}
      onGoBack={() => navigate(-1)}
      goBackCaption={t('common.backToLastPage')}
      dataTestId={dataTestId}
    />
  )
}
